export default __webpack_public_path__ + "fea4a6e.mp3";